import React from 'react';
import FormSection from '../../../FormElements/FormSection';
import Label from '../../../FormElements/Label';
import TextInput from '../../../FormElements/TextInput';
import PrimaryButton from '../../../Buttons/PrimaryButton';
import SecondaryButton from '../../../Buttons/SecondaryButton';

export default class OrganizationFormSection extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			generalExciseUseType: '',
			generalExciseUseEffectiveDate: '',
			generalExciseUseFilingFrequency: 'Monthly',
			generalExciseUseFeeAmount: 20.0,
			transientAccommodationsEffectiveDate: '',
			transientAccommodationsFilingFrequency: 'Monthly',
			transientAccommodationsUnits: '',
			transientAccommodationsFeeAmount: ''
		};

		this.onChange = this.onChange.bind(this);
	}

	componentDidMount() {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	}

	render() {
		// console.log('OrganizationFormSection', this.props);
		return (
			<div className="w-full py-4">
				<FormSection>
					<Label htmlFor="generalExciseUseType">generalExciseUseType *</Label>
					<TextInput
						id="generalExciseUseType"
						name="generalExciseUseType"
						value={this.state.generalExciseUseType}
						onChange={this.onChange}
					/>
					<Label htmlFor="generalExciseUseEffectiveDate">
						generalExciseUseEffectiveDate *
					</Label>
					<TextInput
						id="generalExciseUseEffectiveDate"
						name="generalExciseUseEffectiveDate"
						value={this.state.generalExciseUseEffectiveDate}
						onChange={this.onChange}
						helperText="We set this date to the first day of next month as that when we will start collecting and remitting your taxes."
					/>
					<Label htmlFor="generalExciseUseFilingFrequency">
						generalExciseUseFilingFrequency
					</Label>
					<TextInput
						id="generalExciseUseFilingFrequency"
						name="generalExciseUseFilingFrequency"
						value={this.state.generalExciseUseFilingFrequency}
						onChange={this.onChange}
					/>
					<Label htmlFor="generalExciseUseFeeAmount">
						generalExciseUseFeeAmount *
					</Label>
					<TextInput
						id="generalExciseUseFeeAmount"
						name="generalExciseUseFeeAmount"
						value={this.state.generalExciseUseFeeAmount}
						onChange={this.onChange}
					/>
					<Label htmlFor="transientAccommodationsEffectiveDate">
						transientAccommodationsEffectiveDate
					</Label>
					<TextInput
						id="transientAccommodationsEffectiveDate"
						name="transientAccommodationsEffectiveDate"
						value={this.state.transientAccommodationsEffectiveDate}
						onChange={this.onChange}
						helperText="We set this date to the first day of next month as that when we will start collecting and remitting your taxes."
					/>
					<Label htmlFor="transientAccommodationsUnits">
						transientAccommodationsUnits
					</Label>
					<TextInput
						id="transientAccommodationsUnits"
						name="transientAccommodationsUnits"
						value={this.state.transientAccommodationsUnits}
						onChange={this.onChange}
					/>
					<Label htmlFor="transientAccommodationsFeeAmount">
						transientAccommodationsFeeAmount
					</Label>
					<TextInput
						id="transientAccommodationsFeeAmount"
						name="transientAccommodationsFeeAmount"
						value={this.state.transientAccommodationsFeeAmount}
						onChange={this.onChange}
					/>
				</FormSection>
				<div />
				<div className="grid">
					<div className="lg:justify-self-end mb-4 lg:mb-0">
						<SecondaryButton
							label="Continue"
							onClick={() => {
								this.props.continueLocation(
									this.state.generalExciseUseType,
									this.state.generalExciseUseEffectiveDate,
									this.state.generalExciseUseFilingFrequency,
									this.state.generalExciseUseFeeAmount,
									this.state.transientAccommodationsEffectiveDate,
									this.state.transientAccommodationsFilingFrequency,
									this.state.transientAccommodationsUnits,
									this.state.transientAccommodationsFeeAmount
								);
								this.props.onSubmit();
							}}
						/>
					</div>
				</div>
			</div>
		);
	}

	onChange(e) {
		let { ...state } = this;
		state[e.target.name] = e.target.value;
		this.setState(state);
	}
}
